import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

import { vIntersection } from '@/directives';
import { ref, onMounted, watch } from 'vue';


const __default__ = {
  name: 'AppInfiniteScroll',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disable: {
    type: Boolean,
    required: true
  },
  debounce: {
    type: Number,
    default: 300,
  },
},
  emits: ["load"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'load', done: (stop?: boolean) => void): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;






const loading = ref(false);
const mounted = ref(false);

// Property for internal stop
const disabled = ref(props.disable);

function intersection() {
  if (!loading.value) {
    loading.value = true;
    emits('load', done);
  }
}

function loadDebounce() {
  if (loading.value) setTimeout(() => {
    loading.value = false;
  }, props.debounce);
}

function done(stop?: boolean) {
  disabled.value = stop ?? props.disable;
  loadDebounce();
}

watch(props, () => {
  disabled.value = props.disable;
});

onMounted(() => {
  setTimeout(() => mounted.value = true, props.debounce);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default"),
    (!disabled.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(loading.value ? 'invisible' : '')
        }, [
          _renderSlot(_ctx.$slots, "loading")
        ], 2 /* CLASS */)), [
          [_unref(vIntersection), intersection]
        ])
      : _createCommentVNode("v-if", true)
  ]))
}
}

})